<template>
  <div>
    <v-menu
      v-model="showColorDialog"
      :close-on-content-click="false"
      max-width="380"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-list-tile
          @click.stop="showColorDialog=true"
        >
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon class="mr-1">color_lens</v-icon> Couleur</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>

      <v-card width="380">
        <v-layout
          row wrap
        >
          <v-flex xs12 class="pa-3">
            <v-layout align-end justify-space-between fill-height>
              <h3>Couleur principale</h3>
              <v-btn icon @click="showColorDialog=false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>

          <v-card-title primary-title class="pt-0 mt-0">
            <h4 class="font-weight-thin font-italic">Sélectionner une couleur, puis fermer cette popup pour sauvegarder</h4>
            <h5>Couleur par défaut pour ce modèle: <v-icon style="vertical-align: middle" large :color="defaultColor">fiber_manual_record</v-icon></h5>
          </v-card-title>

          <swatches v-model="cvColor1" colors="material-basic" inline/>

          <v-card-text>
            <p>(code couleur : {{ cvColor1 }})</p>
          </v-card-text>

        </v-layout>
      </v-card>
    </v-menu>
  </div>


</template>

<script>
 import Swatches from 'vue-swatches'
 // Import the styles too, globally
 import "vue-swatches/dist/vue-swatches.min.css"

 import { mapActions, mapState } from 'vuex';

 export default {
   components: { Swatches }, // window.VueSwatches.default - from CDN
   data () {
     return {
       color1: '#42A5F5',
       showColorDialog: false,
     }
   },
   methods: {
     ...mapActions('cvVuex', [
       'getCvModelObject',
       'updateCvModelObject',
     ]),
   },
   computed: {
     defaultColor: function() {
       var defaultTemplate = this.$store.getters['cvVuex/getDefaultTemplate']
       return defaultTemplate.default_cv_color1
     },
     // cvColor1 est le getter/setter pour le component 'Swatches'
     // NOTE : set() n'effectue pas de MAJ sur le modèle!
     // c'est updateCvModelObject() - appellé lors de la fermeture du dialog -
     // qui effectue la transaction.
     cvColor1: {
       get() {
         console.log("***************************  cvColor1  ----")

         // Récupère la couleur par DEFAUT du template associé
         var defaultTemplate = this.$store.getters['cvVuex/getDefaultTemplate']
         console.log('COLOR1 par defaut : ' + defaultTemplate.default_cv_color1)

         // récupère la couleur du template associé
         var theTemplate = this.$store.getters['cvVuex/getRelatedTemplate']
         console.log('COLOR1 : ' + theTemplate)
         console.log('--- get de la COLOR1 : ' + theTemplate.cv_color1)

         // Si aucune couleur n'a été sélectionnée par l'utilisateur :
         // fallback sur la couleur par défaut du template.
         if (!theTemplate.cv_color1) {
           console.log("COLOR : Pas de couleur choisie par le user. Fallback")
           return defaultTemplate.default_cv_color1
         } else {
           console.log("COLOR : le user a sélectionné une couleur")
           return theTemplate.cv_color1
         }
       },
       set(value) {
         // NOTE : on envoie un objet qui est ensuite décomposé dans la mutation MODEL_OBJECT_2
         // noter le namespace 'module/MUTATION'
         this.$store.commit( 'cvVuex/CV_MODEL_UPDATE_COLOR', value)
       }
     },
     ...mapState('cvVuex', [
       'vuexCvModel',
     ]),
   },
   watch: {
     showColorDialog(val) {
       /* Astuce de jon en personne!!! https://github.com/vuetifyjs/vuetify/issues/3478 */
       if(!val) {
         console.log('======== Update de la couleur ========');
         var theTemplate = this.$store.getters['cvVuex/getRelatedTemplate']
         console.log('the template : ')
         console.log(theTemplate)
         this.updateCvModelObject({ 'cvid':this.vuexCvModel.id,
                                    'data_sent': { 'mod_m2m': theTemplate }});
       }
     }
   },
 }
</script>
